(function () {
    "use strict";
  
    function isCountdownVisible() {
      const el = document.querySelector('.countdown-timer-bar');
      if (!el) return false;
  
      const rect = el.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    }
  
    function updateBurgerMenuHeight() {
      const countdown = document.querySelector('.countdown-timer-bar');
      const burgerMenu = document.querySelector('.burger-menu__wrapper');
      if (!countdown || !burgerMenu) return;
  
      const visible = isCountdownVisible();
  
      if (visible) {
        const countdownHeight = countdown.getBoundingClientRect().height;
        const heightValue = `calc(100% - 6vh - ${countdownHeight}px)`;
        burgerMenu.style.height = heightValue;
        // console.log('✅ Countdown visible. Applied height:', heightValue);
      } else {
        burgerMenu.style.height = 'calc(100% - 6vh)';
        // console.log('❌ Countdown hidden. Applied fallback height.');
      }
    }
  
    function onDOMContentLoaded() {
      // Call it unconditionally
   
  
      updateBurgerMenuHeight(); // Initial call
      window.addEventListener('scroll', updateBurgerMenuHeight);
      window.addEventListener('resize', updateBurgerMenuHeight);
    }
  
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", onDOMContentLoaded, { once: true });
    } else {
      onDOMContentLoaded();
    }
  })();